import { createContext } from 'react';

export const AccoutTeamContext = createContext(null);
export const NotifyContext = createContext(null);
